import { match } from 'pinyin-pro';
const getters = {
  menuitems: state => state.menu.items,
  isLoadRoutes: state => state.menu.isLoadRoutes,
  pageSize: state => {
    return window.innerHeight < 900 ? 10 : 20;
  },
  projectUsers(state) {
    return (projectId, defaultValue = []) => {
      const users = state.users[projectId] || defaultValue;
      if (users) {
        const currentUser = []; // 当前用户
        const normalUsers = []; // 普通用户
        const resignUsers = []; // 离职用户
        // 一次遍历，将用户分成三部分
        for (const user of users) {
          if (user.id === state.userInfo.id) {
            currentUser.push(user);
          } else if (user.status === 1) {
            resignUsers.push(user);
          } else {
            normalUsers.push(user);
          }
        }
        // 合并结果
        return [...currentUser, ...normalUsers, ...resignUsers];
      }
      return users;
    };
  },
  filterUser: state => {
    return (projectId = 0, keyword = null, maxCount = 10) => {
      const stateUser = state.users[projectId] || [];
      if (!keyword) return stateUser.slice(0, maxCount);
      const users = [];
      for (const user of stateUser) {
        if (maxCount === 0) break;
        if (match(user.nickname, keyword) || match(user.name, keyword)) {
          users.push(user);
          maxCount--;
        }
      }
      return users;
    };
  },
  globalConfig(state) {
    return (configKey, defaultValue = []) => {
      return state.globalConfigList[configKey] || defaultValue;
    };
  },
  getGlobalBusinessStatus(state) {
    return tepId => {
      let businessTypeData = {};
      if (state.globalConfigList && state.globalConfigList.business_template_steps) {
        businessTypeData = state.globalConfigList.business_template_steps;
      }

      // 如果businessTypeData有值，获取第一个businessTypeData的第一个value的tepId
      if (businessTypeData && Object.keys(businessTypeData).length > 0) {
        const firstTepId = Object.keys(businessTypeData)[0];
        const firstTepIdData = businessTypeData[firstTepId];
        if (!firstTepIdData.tepId) {
          return businessTypeData;
        }
      }

      // 如果tepId为空、null、undefined或0，则使用默认值18
      const targetTepId = tepId || 18;
      // 过滤并返回匹配tepId的数据
      const filteredData = {};
      Object.keys(businessTypeData).forEach(key => {
        if (businessTypeData[key].tepId === targetTepId) {
          filteredData[key] = businessTypeData[key];
        }
      });

      return filteredData;
    };
  }
};

export default getters;
